import type { RouteRecordRaw } from 'vue-router'
import { RoleHelper } from '@/helpers/RoleHelper.ts'
import { AssignmentIcon, CalendarIcon, CaptureIcon, ClockCheckIcon, CustomerEvaluationIcon, EffortCaptureIcon, ModuleIcon, WorkTimeOverviewIcon } from '@/config/icons.ts'

const DashboardView = async () => import('@/views/DashboardView.vue')
const CaptureView = async () => import('@/views/effort/CaptureView.vue')
const NotImplementedView = async () => import('@/views/NotImplementedView.vue')
const ModuleListView = async () => import('@/views/other/ModuleListView.vue')

const MyAssignmentsList = async () => import('@/views/report/MyAssignmentsList.vue')
const HistoryView = async () => import('@/views/effort/HistoryView.vue')
const TeamOverviewView = async () => import('@/views/other/TeamOverviewView.vue')
const WorkingTimeView = async () => import('@/views/other/WorkingTimeView.vue')

const ChannelManagementView = async () => import('@/views/other/ChannelManagementView.vue')
const InquiryListView = async () => import('@/views/whistleblower/InquiryListView.vue')
const InquiryQueryView = async () => import('@/views/whistleblower/InquiryQueryView.vue')
const InquiryView = async () => import('@/views/whistleblower/InquiryView.vue')
const InfoboardNewEntryView = async () => import('@/views/infoboard/InfoboardNewEntryView.vue')
const InfoboardOverviewView = async () => import('@/views/infoboard/InfoboardOverviewView.vue')
const InfoboardNewIncommingEntriesView = async () => import('@/views/infoboard/InfoboardNewIncommingEntriesView.vue')
const ErrorTrackingView = async () => import('@/views/other/ErrorTrackingView.vue')
const TimetrackingView = async () => import('@/views/timetracking/TimetrackingView.vue')
const SentMailsView = async () => import('@/views/development/SentMailsView.vue')
const JourFixeView = async () => import('@/views/jour-fixe/JourFixeView.vue')
const JourFixeModeratorView = async () => import('@/views/jour-fixe/JourFixeModeratorView.vue')
const ExternalUrlRedirectView = async () => import('@/views/ExternalUrlRedirectView.vue')
const EmployeeIllnessView = async () => import('@/views/other/EmployeeIllnessView.vue')
const HolidayBookingView = async () => import('@/views/other/HolidayBookingView.vue')

const CalendarView = async () => import('@/views/pm/CalendarView.vue')
const TitropCommitsView = async () => import('@/views/development/TitropCommitsView.vue')
const WorkTimeOverviewView = async () => import('@/views/worktimetracking/WorkTimeOverviewView.vue')
const PendingCorrectionRequestsView = async () => import('@/views/worktimetracking/PendingCorrectionRequestsView.vue')
const TeamOverview2View = async () => import('@/views/other/TeamOverview2View.vue')
const OrganizationView = async () => import('@/views/static/OrganizationView.vue')
const RoadmapView = async () => import('@/views/static/RoadmapView.vue')
const ChangelogView = async () => import('@/views/static/ChangelogView.vue')
const TimePlanningCaptureView = async () => import('@/views/timeplanning/TimePlanningCaptureView.vue')
const TimePlanningOverviewView = async () => import('@/views/timeplanning/TimePlanningOverviewView.vue')
const TimePlanningGraphicOverviewView = async () => import('@/views/timeplanning/TimePlanningGraphicOverviewView.vue')

const EmployeeColorsView = async () => import('@/views/development/EmployeeColors.vue')
const OrdersView = async () => import('@/views/order/OrdersView.vue')
const SyncObjectTestView = async () => import('@/views/development/SyncObjectTestView.vue')
const RootUrlLayoutView = async () => import('@/views/utility/RootUrlLayoutView.vue')
const CustomerEvaluationView = async () => import('@/views/customer-evaluation/CustomerEvaluationView.vue')

const ToDoListView = async () => import('@/views/other/ToDoListView.vue')
const ImprovementsView = async () => import('@/views/other/ImprovementsView.vue')
const ChannelView = async () => import('@/views/report/ChannelView.vue')
const DeletedEffortEntriesView = async () => import('@/views/report/DeletedEffortEntriesView.vue')
const TaskOverviewView = async () => import('@/views/task/TaskOverviewView.vue')
const NewTaskRequestView = async () => import('@/views/task/NewTaskRequestView.vue')
const EmployeeIllnessOverviewView = async () => import('@/views/analysis/EmployeeIllnessOverviewView.vue')
const EffortsClosedWithAvailableBudgetView = async () => import('@/views/analysis/EffortsClosedWithAvailableBudgetView.vue')
const DashboardNewView = async () => import('@/views/development/DashboardNewView.vue')
const FileUploadView = async () => import('@/views/uploads/FileUploadView.vue')
const PM_WorkloadView = async () => import('@/views/pm/WorkloadView.vue')
const PM_WorkloadView2 = async () => import('@/views/pm/WorkloadViewFail.vue')
const PM_NewPlannerEntryView = async () => import('@/views/pm/NewPlannerEntryView.vue')
const PM_OverviewView = async () => import('@/views/pm/OverviewView.vue')
const PM_PersonalView = async () => import('@/views/pm/PersonalView.vue')

const seperator: RouteRecordRaw = {
  path: 'separator',
  component: NotImplementedView,
  name: 'seperator',
  props: false
}
const routes: RouteRecordRaw[] = [
  {
    meta: { title: 'Dashboard', icon: 'DashboardIcon' },
    path: '/',
    name: 'home',
    component: DashboardView
  },

  {
    path: '/effort',
    name: 'nav_capture',
    meta: { title: 'Leistungserfassung', icon: 'EffortCaptureIcon' },
    component: RootUrlLayoutView,
    children: [
      {
        meta: {
          title: 'Neue Leistung erfassen',
          icon: 'CaptureIcon',
          description: 'Ermöglicht das schnelle Eintragen einer neuen Arbeitsleistung. Ideal, um Tätigkeiten direkt zu dokumentieren.'
        },
        path: '/effort/capture/',
        name: 'effort_capture',
        component: CaptureView,
        props: (route) => {
          return { preselectEffort: route.query.effort }
        }
      },
      {
        meta: {
          title: 'Time-Tracking',
          icon: 'TimeTrackingIcon',
          description: 'Dient zur Erfassung und Verwaltung der eigenen Arbeitszeit. Unterstützt bei der genauen Nachverfolgung täglicher Aktivitäten.'
        },
        path: '/time-tracking',
        name: 'time-tracking',
        component: TimetrackingView
      },
      {
        path: '/assignments',
        meta: {
          title: 'Zuweisungen',
          icon: 'AssignmentIcon',
          description: 'Zeigt Aufgaben oder Leistungen, die bestimmten Mitarbeitenden zugeordnet sind. Hilft bei der transparenten Verteilung von Verantwortlichkeiten.'
        },
        name: 'assignments',
        component: MyAssignmentsList,
        props: true
      },
      {
        meta: {
          title: 'Leistungshistorie',
          icon: 'EffortHistoryIcon',
          description: 'Bietet einen Überblick über alle erfassten Leistungen im Zeitverlauf. Ermöglicht eine einfache Nachverfolgung vergangener Tätigkeiten.'
        },
        path: '/effort/history',
        name: 'history',
        component: HistoryView,
        props: true
      }
    ]
  },
  {
    path: '/working-time',
    name: 'working_hours',
    meta: { title: 'Arbeitszeiterfassung', icon: 'StopwatchIcon' },
    component: RootUrlLayoutView,
    children: [
      {
        path: '/working-time/capture',
        meta: {
          title: 'Erfassung',
          icon: 'StopwatchPlusIcon',
          description: 'Hier können Arbeitszeiten direkt eingetragen oder gestartet werden. Ideal für die tägliche Zeiterfassung.'
        },
        name: 'working-time-capture',
        component: WorkingTimeView
      },
      {
        path: '/working-time/overview',
        meta: {
          title: 'Übersicht',
          icon: 'WorkTimeOverviewIcon',
          description: 'Zeigt alle erfassten Arbeitszeiten in strukturierter Form. Hilft, den eigenen Zeitverlauf schnell zu überblicken.'
          //security: (roleHelper: RoleHelper) => roleHelper.management
        },
        name: 'working-time-overview',
        component: WorkTimeOverviewView
      },
      {
        path: '/working-time/correction_requests',
        meta: {
          title: 'Ausstehende Korrekturanfragen',
          markAsAdmin: true,
          description: 'Listet offene Anträge auf Änderung bereits erfasster Zeiten. Ermöglicht eine einfache Verwaltung und Bearbeitung von Korrekturen.',
          security: (roleHelper: RoleHelper) => roleHelper.management
        },
        name: 'working-time-corr-requests',
        component: PendingCorrectionRequestsView
      },
      seperator,
      {
        path: '/other/holiday',
        meta: {
          title: 'Urlaub',
          icon: 'IslandIcon',
          description: 'Ermöglicht das Eintragen bereits genehmigter Urlaubstage. Vereinfacht die Meldung bestätigter Abwesenheiten an das Unternehmen.'
        },
        name: 'other_holiday',
        component: HolidayBookingView
      },
      {
        path: '/other/illness',
        meta: {
          title: 'Krankmeldung',
          icon: 'HospitalIcon',
          description: 'Ermöglicht das Einreichen und Dokumentieren von Krankmeldungen. Vereinfacht die Meldung von Krankheitstagen an das Unternehmen.'
          //markAsBeta: false
          //security: (roleHelper: RoleHelper) => roleHelper.beta
        },
        name: 'other_illness',
        component: EmployeeIllnessView
      }
    ]
  },
  {
    meta: { title: 'Zeitplanung', icon: 'ClockIcon' },
    path: '/time-planning',
    name: 'time_planning',
    component: RootUrlLayoutView,
    children: [
      {
        path: '/time-planning/capture',
        meta: {
          title: 'Planung',
          icon: 'ClockPlusIcon',
          description: 'Ermöglicht das Erstellen und Anpassen von Einsatz- und Arbeitsplänen. Unterstützt bei der strukturierten Planung von Arbeitszeiten.'
        },
        name: 'time_planning_capture',
        component: TimePlanningCaptureView,
        props: true
      },
      {
        path: '/time-planning/overview',
        meta: {
          title: 'Übersicht',
          icon: 'ClockCheckIcon',
          description: 'Zeigt alle geplanten Arbeitszeiten in kompakter Form. Vereinfacht die Kontrolle und Nachverfolgung der eingetragenen Planungen.'
        },
        name: 'time_planning_overview',
        component: TimePlanningOverviewView,
        props: true
      },
      {
        path: '/time-planning/chart',
        meta: {
          title: 'Grafische Übersicht',
          icon: 'ChartIcon',
          description: 'Stellt die geplanten Zeiten visuell dar, z. B. als Kalender oder Diagramm. Erleichtert das schnelle Erkennen von Mustern, Lücken und Überschneidungen.'
        },
        name: 'time_planning_graphic_overview',
        component: TimePlanningGraphicOverviewView,
        props: true
      }
    ]
  },
  {
    meta: { title: 'Projekt-Management', icon: 'ProjectIcon' },
    path: '/project-management',
    name: 'project-management',
    component: RootUrlLayoutView,
    children: [
      {
        path: '/project-management/orders',
        meta: {
          title: 'Auftragsübersicht',
          icon: 'OrderOverviewIcon',
          description: 'Zeigt alle aktuellen Aufträge und deren Status auf einen Blick. Vereinfacht die Verwaltung und Priorisierung laufender Projekte.'
          //security: (roleHelper: RoleHelper) => roleHelper.beta
        },
        name: 'orders',
        component: OrdersView
      },
      /*{
       path: '/project-management/overview',
       meta: {
       title: 'Übersicht',
       markAsDev: true,
       security: (roleHelper: RoleHelper) => roleHelper.developer
       },
       name: '',
       component: PM_OverviewView,
       props: () => {
       const p: { range: Interval<true> } = {
       range: Interval.fromDateTimes(DateTime.now().startOf('month'), DateTime.now().endOf('month')) as Interval<true>
       }
       return p
       }
       },
       {
       path: '/project-management/workload',
       meta: {
       title: 'Auslastungsübersicht',
       markAsDev: true,
       security: (roleHelper: RoleHelper) => roleHelper.developer
       },
       name: 'pm_workload',
       component: PM_WorkloadView,
       props: (r: RouteLocationNormalized) => {
       let range: Interval<true> | undefined = undefined
       let start: DateTime<true> | undefined = undefined
       let end: DateTime<true> | undefined = undefined
       const qry = r.query
       if (qry.s) {
       const t = DateTime.fromISO(qry.s.toString())
       if (t.isValid) start = t
       }
       if (qry.e) {
       const t = DateTime.fromISO(qry.e.toString())
       if (t.isValid) end = t
       }

       if (!start) start = DateTime.now().startOf('month')
       if (!end) end = DateTime.now().endOf('month')

       if (qry.range || qry.r) {
       const rStr = qry.range?.toString() ?? qry.r?.toString()
       if (rStr) {
       const t = Interval.fromISO(rStr)
       if (t.isValid) range = t
       }
       } else {
       const t = Interval.fromDateTimes(start, end)
       if (t.isValid) range = t
       }
       return {
       range: range
       }
       }
       },
       {
       path: '/project-management/workload2',
       meta: {
       title: 'Auslastungsübersicht FAILED',
       markAsDev: true,
       security: (roleHelper: RoleHelper) => roleHelper.developer
       },
       name: 'pm_workload2',
       component: PM_WorkloadView2,
       props: (r: RouteLocationNormalized) => {
       let range: Interval<true> | undefined = undefined
       let start: DateTime<true> | undefined = undefined
       let end: DateTime<true> | undefined = undefined
       const qry = r.query
       if (qry.s) {
       const t = DateTime.fromISO(qry.s.toString())
       if (t.isValid) start = t
       }
       if (qry.e) {
       const t = DateTime.fromISO(qry.e.toString())
       if (t.isValid) end = t
       }

       if (!start) start = DateTime.now().startOf('month')
       if (!end) end = DateTime.now().endOf('month')

       if (qry.range || qry.r) {
       const rStr = qry.range?.toString() ?? qry.r?.toString()
       if (rStr) {
       const t = Interval.fromISO(rStr)
       if (t.isValid) range = t
       }
       } else {
       const t = Interval.fromDateTimes(start, end)
       if (t.isValid) range = t
       }
       return {
       range: range
       }
       }
       },
       {
       path: '/project-management/personal',
       meta: {
       title: 'Eigener Kalender',
       markAsDev: true,
       security: (roleHelper: RoleHelper) => roleHelper.developer
       },
       name: '',
       component: PM_PersonalView,
       props: (r: RouteLocationNormalized) => {
       let range: Interval<true> | undefined = undefined
       let start: DateTime<true> | undefined = undefined
       let end: DateTime<true> | undefined = undefined
       const qry = r.query
       if (qry.s) {
       const t = DateTime.fromISO(qry.s.toString())
       if (t.isValid) start = t
       }
       if (qry.e) {
       const t = DateTime.fromISO(qry.e.toString())
       if (t.isValid) end = t
       }

       if (!start) start = DateTime.now().startOf('month')
       if (!end) end = DateTime.now().endOf('month')

       if (qry.range || qry.r) {
       const rStr = qry.range?.toString() ?? qry.r?.toString()
       if (rStr) {
       const t = Interval.fromISO(rStr)
       if (t.isValid) range = t
       }
       } else {
       const t = Interval.fromDateTimes(start, end)
       if (t.isValid) range = t
       }
       return {
       range: range
       }
       }
       },
       {
       path: '/project-management/2',
       meta: {
       title: 'Grafische Übersicht',
       markAsDev: true,
       security: (roleHelper: RoleHelper) => roleHelper.developer
       },
       name: 'project-management-2',
       component: NotImplementedView
       },
       {
       path: '/project-management/new-entry',
       meta: {
       title: 'Neuen Eintrag anlegen',
       markAsDev: true,
       security: (roleHelper: RoleHelper) => roleHelper.developer
       },
       name: 'pm_new-entry',
       component: PM_NewPlannerEntryView
       },*/
      {
        path: '/project-management/calendar',
        meta: {
          title: 'Kalender',
          icon: 'CalendarIcon',
          description: 'Stellt projektbezogene Termine und Fristen im Kalender dar. Unterstützt bei der zeitlichen Planung und Koordination von Aufgaben.'
        },
        name: 'pm_effort_calendar',
        component: CalendarView,
        props: (r) => {
          return { preselectDate: (r.query.preselectDate ?? r.query['preselect-date'])?.toString() }
        }
      }
    ]
  },
  {
    meta: { title: 'Sonstiges', icon: 'OtherMenuIcon' },
    path: '/other',
    name: 'other',
    component: RootUrlLayoutView,
    children: [
      {
        path: '/other/team-overview',
        meta: {
          title: 'Mitarbeiterübersicht',
          icon: 'UsersIcon',
          description: 'Zeigt eine vollständige Liste aller Mitarbeitenden. Erleichtert die Einsicht in Zuständigkeiten und grundlegende Informationen.'
        },
        name: 'team-overview',
        component: TeamOverviewView
      },

      // {
      //   path: '/other/improvements',
      //   meta: { title: 'Verbesserungsvorschläge' },
      //   name: 'improvements',
      //   component: ImprovementsView
      // },
      {
        path: '/other/errortrack',
        meta: {
          title: 'Fehlerberichte',
          icon: 'BugIcon',
          description: 'Ermöglicht das Einsehen und Verwalten gemeldeter Fehler. Unterstützt dabei, Probleme schnell zu erkennen und zu bearbeiten.'
        },
        name: 'errortrack',
        component: ErrorTrackingView
      },
      {
        path: '/other/modules',
        meta: {
          title: 'Modulliste',
          icon: 'ModuleIcon',
          description: 'Listet alle verfügbaren Module der Firma auf. Bietet einen klaren Überblick über Funktionen und Erweiterungen.'
        },
        name: 'modules',
        component: ModuleListView
      },
      {
        path: '/other/channel-management',
        meta: {
          title: 'Channel-Verwaltung',
          icon: 'ChannelOverviewIcon',
          description: 'Dient zur Verwaltung interner Kommunikations- oder Informationskanäle. Vereinfacht die Organisation und Strukturierung von Kanälen.'
        },
        name: 'channel-management',
        component: ChannelManagementView
      },
      /*{
       path: '/other/todolist',
       meta: {
       title: 'ToDo-Liste',
       markAsBeta: true,
       security: (roleHelper: RoleHelper) => roleHelper.beta
       },
       name: 'todo',
       component: ToDoListView
       },
       {
       path: '/report/channel',
       meta: {
       title: 'Channel-Ansichten',
       markAsDev: true,
       security: (roleHelper: RoleHelper) => roleHelper.developer
       },
       name: 'ChannelOverView',
       component: ChannelView
       },
       {
       path: '/uploads',
       meta: {
       title: 'Datei-Manager',
       markAsDev: true,
       security: (roleHelper: RoleHelper) => roleHelper.beta
       },
       name: 'Uploads',
       component: FileUploadView
       },*/
      {
        path: '/whistleblower/inquiry',
        meta: {
          title: 'Whistleblower - Einreichen',
          icon: 'WhistleblowerAddIcon',
          description: 'Ermöglicht das vertrauliche Einreichen eines Whistleblower-Hinweises. Vereinfacht die sichere Meldung sensibler Vorkommnisse.'
        },
        name: 'whistleblower_inquiry',
        component: InquiryView
      },
      {
        path: '/whistleblower/query',
        meta: {
          title: 'Whistleblower - Statusabfrage',
          icon: 'WhistleblowerStateIcon',
          description: 'Zeigt den aktuellen Bearbeitungsstatus eines eingereichten Hinweises. Unterstützt die transparente Nachverfolgung laufender Meldungen.'
        },
        name: 'whistleblower_query',
        component: InquiryQueryView
      },
      {
        path: '/whistleblower/agentview',
        meta: {
          title: 'Whistleblower - Übersicht',
          security: (roleHelper: RoleHelper) => roleHelper.whistleblow_agent,
          icon: 'WhistleblowerOverviewIcon',
          description: 'Bietet eine vollständige Übersicht aller Whistleblower-Fälle. Erleichtert die Verwaltung, Priorisierung und Dokumentation eingegangener Hinweise.'
        },
        name: 'whistleblower_agentview',
        component: InquiryListView
      },
      {
        path: 'business-partner-evaluation',
        meta: {
          title: 'Kunde-Fragebogen',
          icon: 'CustomerEvaluationIcon',
          security: (roleHelper: RoleHelper) => roleHelper.sales_person || roleHelper.department_leader
        },
        name: 'customer-evaluation',
        component: CustomerEvaluationView
      },
      {
        path: '/changelog',
        meta: {
          title: 'Changelog',
          icon: 'ChangelogIcon',
          description: 'Zeigt eine chronologische Übersicht aller Änderungen und Updates des Titrop-Systems.'
        },
        name: 'changelog',
        component: ChangelogView
      }
    ]
  },

  {
    meta: { title: 'Infoboard', icon: 'ChatIcon' },
    path: '/infoboard',
    name: 'nav_infoboard',
    component: RootUrlLayoutView,
    children: [
      {
        path: '/infoboard/news',
        meta: {
          title: 'Neueste Beiträge',
          icon: 'InfoboardNewItemIcon',
          description: 'Zeigt die aktuellsten veröffentlichten Beiträge. Erleichtert den schnellen Überblick über neue Informationen.'
        },
        name: 'infoboard-news',
        component: InfoboardNewIncommingEntriesView
      },
      {
        path: '/infoboard/overview',
        meta: {
          title: 'Übersicht',
          icon: 'InfoboardOverviewIcon',
          description: 'Bietet eine vollständige Liste aller Beiträge. Vereinfacht die Verwaltung und Navigation durch vorhandene Inhalte.'
        },
        name: 'infoboard-overview',
        component: InfoboardOverviewView
      },
      {
        path: '/infoboard/new-topic',
        meta: {
          title: 'Neuen Beitrag erstellen',
          icon: 'InfoboardCaptureIcon',
          description: 'Ermöglicht das Erstellen und Veröffentlichen neuer Beiträge. Vereinfacht das Teilen wichtiger Informationen mit dem Unternehmen.'
        },
        name: 'infoboard-new-topic',
        component: InfoboardNewEntryView
      }
    ]
  },


  /*{
   meta: {
   title: 'Anfragenverwaltung',
   markAsBeta: true,
   security: (roleHelper: RoleHelper) => roleHelper.beta
   },
   path: '/task',
   children: [
   {
   path: '/task/new',
   meta: { title: 'Neue Anfrage erstellen' },
   name: 'task-new-request',
   component: NewTaskRequestView
   },
   {
   path: '/task/overview',
   meta: { title: 'Übersicht' },
   name: 'task-overview',
   component: TaskOverviewView
   }
   ]
   },*/
  /*{
   meta: {
   title: 'Auswertungen',
   markAsAdmin: true,
   security: (roleHelper: RoleHelper) => roleHelper.department_leader || roleHelper.management
   },
   path: '/analysis',
   name: 'nav_analysis',
   children: [
   {
   path: '/analysis/illness-overview',
   meta: {
   title: 'Krankenliste',
   markAsReviewRequired: true,

   markAsDev: true,
   security: (roleHelper: RoleHelper) => roleHelper.developer
   },
   name: 'analysis_employee-illness-overview',
   component: EmployeeIllnessOverviewView
   },
   {
   path: '/analysis/deleted-effort-entries',
   name: 'analysis_deleted-effort-entries',
   component: DeletedEffortEntriesView,
   meta: {
   title: 'Gelöschte Leistungen',
   markAsDev: true,
   security: (roleHelper: RoleHelper) => roleHelper.developer
   }
   },
   {
   path: '/analysis/efforts-closed-with-available-budget-view',
   name: 'analysis_efforts-closed-with-available-budget-view',
   component: EffortsClosedWithAvailableBudgetView,
   meta: {
   title: 'Geschlossene Objekte mit Restbudget',
   markAsAdmin: true,
   security: (roleHelper: RoleHelper) => roleHelper.admin
   }
   }
   ]
   },*/
  {
    meta: { title: 'Beta-Test', markAsBeta: true, security: (roleHelper: RoleHelper) => roleHelper.beta },
    path: '/beta',
    name: 'nav_beta',
    component: RootUrlLayoutView,
    children: []
  },
  {
    meta: {
      title: 'Entwicklerbereich',
      markAsDev: true,
      security: (roleHelper: RoleHelper) => roleHelper.developer
    },
    path: '/developer',
    name: 'nav_developer',
    component: RootUrlLayoutView,
    children: [
      {
        path: '/jour-fixe',
        meta: {
          title: 'Jour-Fixe',
          security: (roleHelper: RoleHelper) => roleHelper.beta
        },
        name: 'jour-fixe',
        component: JourFixeView
      },
      {
        path: '/jour-fixe-moderation',
        meta: {
          title: 'Jour-Fixe-Moderator',
          security: (roleHelper: RoleHelper) => roleHelper.developer
        },
        name: 'jour-fixe-moderation',
        component: JourFixeModeratorView
      },
      {
        path: '/developer/sent-mails',
        meta: {
          title: 'Versandte Emails',
          security: (roleHelper: RoleHelper) => roleHelper.developer
        },
        name: 'developer_sentmails',
        component: SentMailsView
      },
      {
        path: '/db-audit',
        meta: {
          title: 'DB-Audit',
          markAsAdmin: true
        },
        name: '',
        component: ExternalUrlRedirectView,
        props: { href: '/audit' }
      },
      {
        path: '/db-admin',
        meta: {
          title: 'DB-Admin',
          markAsDev: true
        },
        name: '',
        component: ExternalUrlRedirectView,
        props: { href: '/admin' }
      },
      {
        path: '/developer/titrop-commits',
        meta: {
          title: 'Titrop-Commits',
          security: (roleHelper: RoleHelper) => roleHelper.developer
        },
        name: 'titrop-commits',
        component: TitropCommitsView
      },
      {
        path: '/other/team-overview2',
        meta: {
          title: 'Mitarbeiterübersicht 2',
          security: (roleHelper: RoleHelper) => roleHelper.developer,
          markAsDev: true,
          markAsReviewRequired: true
        },
        name: 'team-overview-2',
        component: TeamOverview2View
      },
      /////////////////////////////////////
      {
        path: '/other/organization',
        meta: {
          title: 'Organigramm',
          markAsDev: true,
          markAsReviewRequired: true,
          security: (roleHelper: RoleHelper) => roleHelper.developer
        },
        name: 'organization',
        component: OrganizationView
      },
      {
        path: '/roadmap',
        meta: {
          title: 'Roadmap',
          markAsReviewRequired: true,
          markAsDev: true,
          security: (roleHelper: RoleHelper) => roleHelper.developer
        },
        name: 'roadmap',
        component: RoadmapView
      },
      {
        path: '/employeecolors',
        meta: {
          title: 'Employee Colors'
        },
        name: 'employeecolors',
        component: EmployeeColorsView
      },
      {
        path: '/syncobjecttest',
        meta: {
          title: 'Sync Object Test'
        },
        name: 'SyncObjectTest',
        component: SyncObjectTestView
      }
    ]
  }
]

export default routes
